import store from '../store';
import questions from './questionsMan';

function buildConfigMan({ config }) {
	const gender = questions.getAnswers({ questionName: 'gender' }).value;
	let buildedConfig = [];

	config.forEach((el, index) => {
		if (el.gender && el.gender !== gender) {
			// Filter all steps by gender
			config.splice(index, 1);
		}
	});

	buildedConfig = [...config];

	if (store.getState().steps.beforeAfterB) {
		buildedConfig.unshift({
			name: 'before_after_b'
		});
	}

	if (store.getState().steps.bigPhotoStartScreen) {
		buildedConfig.unshift({
			name: 'big_photo_start_screen'
		});
	}

	if (store.getState().steps.ageGroupStartScreen) {
		buildedConfig.unshift({
			name: 'age_group_start_screen'
		});
	}

	if (store.getState().steps.zonesStartScreen) {
		buildedConfig.unshift({
			name: 'zones_start_screen'
		});
	}

	if (store.getState().steps.xmasStartScreen) {
		buildedConfig.unshift({
			name: 'xmas_start_screen'
		});
	}

	if (store.getState().steps.newYearStartScreen) {
		buildedConfig.unshift({
			name: 'new_year_start_screen'
		});
	}

	return buildedConfig;
}

export default buildConfigMan;
